module.exports = __webpack_public_path__ + "static/media/P200-sm-close.694aee53.svg";